import React from "react";
import NumberFormat from "react-number-format";

import { Stack, TextField } from "@mui/material";

import { ContactState } from "../context/DealCreateContext";

interface Props {
  contact: ContactState;
  onFieldChange: (field: keyof ContactState, value: string) => void;
}

export const DealContactFields: React.FC<Props> = ({ contact, onFieldChange }) => {
  return (
    <Stack sx={{ gap: "20px" }}>
      <Stack direction="row" gap="20px">
        <TextField
          fullWidth
          label="First Name"
          value={contact.first_name}
          onChange={(e) => onFieldChange("first_name", e.target.value)}
        />
        <TextField
          fullWidth
          label="Last Name"
          value={contact.last_name}
          onChange={(e) => onFieldChange("last_name", e.target.value)}
        />
      </Stack>
      <Stack direction="row" gap="20px">
        <TextField
          fullWidth
          label="Title"
          value={contact.title}
          onChange={(e) => onFieldChange("title", e.target.value)}
        />
        <TextField
          fullWidth
          label="Firm"
          value={contact.firm}
          onChange={(e) => onFieldChange("firm", e.target.value)}
        />
      </Stack>
      <Stack direction="row" gap="20px">
        <NumberFormat
          isNumericString
          fullWidth
          label="Phone Number"
          customInput={TextField}
          defaultValue={contact.phone_number}
          onValueChange={({ value }) => onFieldChange("phone_number", value)}
        />
        <TextField
          fullWidth
          label="Email Address"
          value={contact.email}
          onChange={(e) => onFieldChange("email", e.target.value)}
        />
      </Stack>
      <TextField
        fullWidth
        label="Address"
        value={contact.address}
        onChange={(e) => onFieldChange("address", e.target.value)}
      />
    </Stack>
  );
};
